import { AxiosError } from 'axios'

export interface Rendition {
  isActive: boolean
  container: string
  url: string
  width: number
}

export interface WebcastInterface {
  status: {
    isFetching: boolean,
    hasData: boolean,
    hasError: boolean
  }
  data: {
    id: number | undefined,
    channel: {
      id: number | undefined
    },
    title: string,
    duration: number | undefined,
    description: string,
    keywords: string,
    presenter: string,
    start: string,
    entryTime: string,
    closeTime: string,
    created: string,
    timeZone: string,
    status: string,
    publishStatus: string,
    visibility: string,
    provider: {
      name?: string,
      renditions?: Rendition[],
      replay?: {
        master: {
          channelId: string
          webcastId: string
        }
      }
    },
    format: string,
    url: string,
    channelWebcastUrl: string,
    customUrl: string,
    links: [],
    showChannelSurvey: boolean | undefined,
    excludeFromChannelCapacity: boolean | undefined,
    allowAnonymous: boolean | undefined,
    categories: [],
    clientBookingReference: string,
    syndication: {
      syndicationIn?: {}
    },
    serviced: boolean,
    rating: string,
    totalViewings: number | undefined,
    communities: [],
    pinNumber?: number,
    lastUpdated?: string
  }
}

interface WebcastCollectionInterface {
  [key: string]: WebcastInterface
}

export interface WebcastReducerInterface {
  collection: WebcastCollectionInterface
  errors: AxiosError['response'] | {}
  newWebcastId: string | null
  status: {
    isFetching: boolean,
    isPostProcessing: boolean,
    isSubmitting: boolean,
    hasData: boolean,
    hasError: boolean,
    postProcessingSuccess: boolean,
    submitSuccess: boolean
  }
}

const defaultState: WebcastReducerInterface = {
  collection: {},
  errors: {},
  newWebcastId: null,
  status: {
    isFetching: false,
    isPostProcessing: false,
    isSubmitting: false,
    hasData: false,
    hasError: false,
    postProcessingSuccess: false,
    submitSuccess: false
  }
}

const defaultWebcast: WebcastInterface = {
  status: {
    isFetching: false,
    hasData: false,
    hasError: false
  },
  data: {
    id: undefined,
    channel: {
      id: undefined
    },
    title: '',
    duration: undefined,
    description: '',
    keywords: '',
    presenter: '',
    start: '',
    entryTime: '',
    closeTime: '',
    created: '',
    timeZone: '',
    status: '',
    publishStatus: '',
    visibility: '',
    provider: {},
    format: '',
    url: '',
    channelWebcastUrl: '',
    customUrl: '',
    links: [],
    showChannelSurvey: undefined,
    excludeFromChannelCapacity: undefined,
    allowAnonymous: undefined,
    categories: [],
    clientBookingReference: '',
    syndication: {},
    serviced: false,
    rating: '',
    totalViewings: undefined,
    communities: []
  }
}

export { defaultState, defaultWebcast }
